import { format } from 'date-fns'

export function convertToUTC(localTime: string) {
  return new Date(localTime).toISOString().substr(0, 23)
}

export function getLocalDate(isoDateTime: Date) {
  return format(isoDateTime, 'yyyy-MM-dd')
}

export function getLocalTime(isoDateTime: Date) {
  return isoDateTime.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  })
}

/**
 * Given a date string and a time string, return a ISO formatted datetime
 *
 * @param date Date string (yyyy-mm-dd)
 * @param time Time string (HH:mm:ss)
 *
 */
export function getISODateTime(date: string, time: string) {
  try {
    const dateTime = new Date(`${date} ${time}`)
    return dateTime.toISOString()
  } catch (e) {
    console.debug(`Exception thrown when parsing string '${date} ${time}'`, e)
    return ''
  }
}

export function validateDateAndRecover(date: Date, fallbackDate = new Date()) {
  if (!Number.isNaN(date.valueOf())) {
    return date
  } else {
    return fallbackDate
  }
}

export function formatDateTime(dateTime: Date | undefined) {
  const formatter = new Intl.DateTimeFormat('en-GB', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  })
  const validDate = validateDateAndRecover(dateTime)
  try {
    return validDate ? formatter.format(validDate) : '-'
  } catch (e) {
    console.debug(`Exception thrown when formatting date `, e)
    return 'invalid date'
  }
}
